import { Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import Home from "./Home";
import { NavLink } from "react-router-dom";
import KwdcHeader from './LoginHeader';
import PublicSiteFooter from './PublicSiteFooter';
// import KwdcHeader from './Header';
export default function ContactPage() {

    return (
        <>
            <KwdcHeader />



            <section className="kwdc-innerpage-about-top mb-0">
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9} className="kwdc-innerpage-about-left">
                            <div className="kwdc-innerpage-about-heading">
                                <h1>Contact Us</h1>
                                <p>
                                    A.P. State Kapu Welfare & Development
                                    Corporation
                                </p>
                            </div>
                        </Col>

                        <Col xxl={4} xl={4} lg={4} md={4} sm={3} xs={3} className="kwdc-about-right"></Col>
                    </Row>
                </Container>
            </section>



            {/* =======================================contact us=================================================== */}
            <section className="kwdc-contact-section">
                <Container>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <iframe
                                title="Pothuri Mercantile Location"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.935652424433!2d80.61511687685943!3d16.47879562833986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f122fa80f819%3A0x5b3a18f72a08aa43!2sPothuri%20Mercantile!5e0!3m2!1sen!2sin!4v1784267987155!5m2!1sen!2sin"
                                className='contact-map'

                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="strict-origin-when-cross-origin"
                            />
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <div className="kwdc-contact-box">


                                <p className="kwdc-contact-text">
                                    Porthuri Mercantile, D.No:12-467,
                                    <br />
                                    2nd & 3rd Floor, Bypass Road NH-16,
                                    <br />
                                    Revenue Ward-12, Tadepalli-522501, Guntur.
                                </p>

                                <p className="kwdc-contact-email">
                                    Email: <a href="mailto:apkwdc@gmail.com">apkwdc@gmail.com</a>
                                </p>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>

            <PublicSiteFooter />
        </>
    );
}







